module.exports = __webpack_public_path__ + "static/img/bdc-kpi-users.525ff212.svg";